export const highlightedTranslations = {
  title: {
    highlight: {
      key: 'highlightModal.title.highlight',
      defaultValue: 'Highlight Widget?',
    },
    unhighlight: {
      key: 'highlightModal.title.unhighlight',
      defaultValue: 'Unhighlight Widget?',
    },
  },

  note: {
    highlight: {
      key: 'highlightModal.note.highlight',
      defaultValue: `Note: Highlighting widget will affect all stores in {{areaName}}`,
    },
    unhighlight: {
      key: 'highlightModal.note.unhighlight',
      defaultValue: `Note: unhighlighting widget will affect all stores in {{areaName}}.`,
    },
  },

  comment: {
    highlight: {
      key: 'highlightModal.comment.highlight',
      defaultValue: `Are you sure you want to highlight the {{widgetName}} widget?`,
    },
    unhighlight: {
      key: 'highlightModal.comment.unhighlight',
      defaultValue: `Are you sure you want to unhighlight the {{widgetName}} widget?`,
    },
  },
  successtext: {
    highlight: {
      key: 'highlightModal.successtext.highlight',
      defaultValue: 'Area KPI has been highlighted successfully!',
    },
    unhighlight: {
      key: 'highlightModal.successtext.unhighlight',
      defaultValue: 'Area KPI has been unhighlighted successfully!',
    },
  },
  errortext: {
    key: 'highlightModal.errortext',
    defaultValue: 'Unable to modify the highlighting status of the widget. Please try again later!',
  },
};
